import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { TagsPage } from './_dashboard.catalog.tags'

export const Route = createFileRoute('/_dashboard/catalog/tags/')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: TagsIndexPage,
})

function TagsIndexPage() {
  return <TagsPage selectedId={undefined} />
}
